
import { computed, defineComponent } from '@nuxtjs/composition-api'
import { getCountryCode } from '~/assets/ts/Locale'

export default defineComponent({
  props: {
    pageroute: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const pageRoute = props.pageroute
    let pageName = ''
    let pageStr = ''

    if (pageRoute.search('___') !== -1) {
      pageName = pageRoute.substr(0, pageRoute.length - 5)

      if (pageName.search('___') !== -1) {
        pageName = pageName.substr(0, pageName.length - 5)
      }

      pageStr = 'pages.' + pageName
    }

    const country = getCountryCode()

    let catalogType = 'engagement' // default

    if (pageName.substring(0, 7) === 'wedding') {
      catalogType = 'wedding'
    } else if (pageName.substring(0, 7) === 'memoire') {
      catalogType = 'eternity'
    } else if (pageName.substring(0, 14) === 'diamondJewelry') {
      catalogType = 'jewelry'
    }

    const collectionByType = computed(() => {

      // if country is KR or US, remove lab grown diamonds from engagement rings
      if ((catalogType === 'engagement') && (country === 'kr' || country === 'us')) {
        const filteredRow1 = collections[catalogType].row1.filter((item: string) => item !== 'engagementRingsLabGrownDiamonds')
        const filteredRow2 = collections[catalogType].row2.filter((item: string) => item !== 'engagementRingsLabGrownDiamonds')
        return { row1: filteredRow1, row2: filteredRow2 }
      }

      return collections[catalogType]
    })

    const collections: { [key: string]: any } = {
      engagement: {
        row1: [
          'engagementRingsBestseller', // Bestseller
          'engagementRings025Carat', // 0.25 Carat
          'engagementRings050Carat', // 0.50 Carat
          'engagementRings070Carat', // 0.70 Carat
          'engagementRings100Carat', // 1.00 Carat
          'engagementRingsSolitaire', // Solitaire
          'engagementRingsDiamonds', // Verlobungsringe mit Diamanten
          'engagementRingsDiamond', // Verlobungsringe mit Brillanten
          'engagementRingsPrincess', // Princess
        ],
        row2: [
          'engagementRingsLabGrownDiamonds', // Lab Grown Diamanten
          'engagementRingsDainty', // Verlobungsringe günstig
          'engagementRingsClassic', // Classic
          'engagementRingsExclusive', // Exclusive
          'engagementRingsHeart', // Herz
          'engagementRingsHalo', // Halo
          'engagementRingsFancy', // Fancy
          'engagementRingsModern', // Modern
          'engagementRingsCollectionRings', // Sammlungsringe
          'engagementRingsVintage', // Vintage
          'engagementRingsTensionRing', // Tension Ring
          'engagementRingsSignature', // Signature
        ],
      },
      wedding: {
        row1: [
          'weddingRingsPlatinum', // Platin - Celeste
          'weddingRingsClassic', // schlichte klassische - Classic
          'weddingRingsDiamonds', // mit Diamanten - Celebration
          'weddingRingsCheap', // Günstige - Smart
          'weddingRingsMillgrif', // Vintage - Millgriff
          'weddingRingsFinishes', // Gehämmert - Structures
          'weddingRingsPlain', // Schlicht Querkanal
          'weddingRingsRingSets', // Ringsets - Übersicht
          'weddingRingsModern', // Moderne - Querkanal
          'weddingRingsSlim', // Schmale - Charme
          'weddingRingsTwoColors', // Zweifarbige - Complement
          'weddingRingsCeramic', // Passion - Hyceran - Keramik
          'weddingRingsCarbon', // Carbon
          'weddingRingsBlack', // Schwarze
        ],
        row2: [
          'weddingRingsBestseller', // Bestseller
          'weddingRingsSoleil', // Soleil
          'weddingRingsPolar', // Polar
          'weddingRingsNaturalBeige', // Natural Beige
          'weddingRingsHearts', // Trauringe mit Herzen
          'weddingRingsFacetes', // Trauringe mit Facetten
          'weddingRingsForestGreen', // Forest Green
          'weddingRingsCrown', // Crown
          'weddingRingsSecretHeart', // Secret Heart
          'weddingRingsFancy', // Fancy
          'weddingRingsSignature', // Signature
          'weddingRingsStarrySky', // Stardust - Sternenhimmel
          'weddingRingsGayLesbianCouples', // Diversity - Gleichgeschlechtlich
          'weddingRingsWaveDesign', // Caresse - Saturn und Welle
          'weddingRingsMokumeGane', // Mokume Gane
          'weddingRingsTensionRings', // Spannringe - Character
        ],
      },
      eternity: {
        row1: [
          'memoireRingsFullSizeMemoires', // Voll ausgefasst
          'memoireRingsHalfSetMemories', // Halb ausgefasst
          'memoireRingsGrowingMemoires', // Wachsen
          'memoireRingsPlatinum', // Platin - Celeste
          'memoireRingsSlim', // Schmale - Charme
          'memoireRingsColored', // Farbige - Farbige
          'memoireRingsExclusive', // Exclusive
        ],
        row2: [
          'memoireRingsBestseller', // Bestseller
          'memoireRingsCheap', // Günstige - Smart
          'memoireRingsSignature', // Signature
          'memoireRingsAsWeddingRings', // als Trauringe
          'memoireRingsRingsets', // Ringsets - Übersicht
        ],
      },
      jewelry: {
        row1: [
          'diamondJewelryDelicateJewels', // Zarte Schmuckstücke
          'diamondJewelryExclusive', // Exclusive
          'diamondJewelryBracelets', // Armbänder
          'diamondJewelryBestseller', // Bestseller
          'diamondJewelrySignet', // Siegelringe
          'diamondJewelryPlatinum', // Platin
        ],
        row2: [
          'diamondJewelryPresentsValentine', // Valentinstag
          'diamondJewelryPresentsWomen', // Morgengabe
          'diamondJewelryPresentsChristmas', // Weihnachtsgeschenke
          'diamondJewelryPresentsYearly', // Hochzeitstag
          'diamondJewelryPresentsMother', // Geburtstag
        ],
      },
    }

    return { pageRoute, pageName, pageStr, catalogType, collectionByType }
  },
})
